import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { ApiService } from 'src/app/shared/Services/api.service';
import { ApiPaths } from 'src/app/job-seeker/Models/api-path';
import { Jobseekerdata } from '../Models/jobseekerdata.model';

interface ReferenceDto {
  companyName: string;
  contactPerson: string;
  jobTitle: string;
  contactPhone: string;
  contactEmail: string;
}

interface ContactDto {
  contactType: string;
  contactValue: string;
}

interface DocDto {
  docType: string;
  docName: string;
  docFile: string;
}

@Injectable({
  providedIn: 'root',
})
export class JobSeekerService {
  public currentResumePath!: string;
  profileId!: number;
  private jsIdSubject = new BehaviorSubject<number | null>(null);
  ProImgPath!: number;
  ResumePath!: number;
  jobSeekerVM!: Jobseekerdata;


  constructor(private apiService: ApiService) {
    this.jobSeekerVM = new Jobseekerdata();
  }


  GetLookUpData(filters: string[]): Observable<any> {
    const localurl = ApiPaths.JobSeeker.LookUpData;
    return this.apiService.post(localurl,filters);
  }

  GetDocsInfo(Id:any): Observable<any> {
    const localurl = ApiPaths.JobSeeker.loadDocInfoData(Id);
    return this.apiService.get(localurl);
  }

  GetLookUpAllotmentData(JsId: number) {
    const localurl = ApiPaths.JobSeeker.LookUpAllotmentData(JsId);
    return this.apiService.get(localurl);
  }

  GetJsJobAllotedInitial(JobId:number){
    const localurl = ApiPaths.JobSeeker.loadJsJobAllotedList(JobId);
    return this.apiService.get(localurl, undefined, false);
  }

  JobDetailInitial(JsId: number) {
    const localurl = ApiPaths.JobSeeker.JobDetailInitial(JsId);
    return this.apiService.get(localurl);
  }

  addProfile(data: any) {
    let url = ApiPaths.JobSeeker.CreateProfile;
    return this.apiService.post(url, data);
  }

  addProfessional(data: any) {
    let url = ApiPaths.JobSeeker.CreateProfessional;
    return this.apiService.post(url, data);
  }

  addReference(references: ReferenceDto[]): Observable<any> {
    let url = ApiPaths.JobSeeker.CreateReference;
    const referenceList = { References: references };
    return this.apiService.post(url, referenceList);
  }

  addSkill(data: any) {
    let url = ApiPaths.JobSeeker.CreateSkill;
    return this.apiService.post(url, data);
  }

  addContact(contactDto: ContactDto[]): Observable<any> {
    let url = ApiPaths.JobSeeker.CreateContact;
    const contactList = { contact: contactDto };
    return this.apiService.post(url, contactList);
  }

  addDoc(docDto: DocDto[], formData: any): Observable<any> {
    let url = ApiPaths.JobSeeker.CreateDoc;
    const docList = { docs: docDto };
    return this.apiService.post(url, docList);
  }
  addDocuments(docDto: DocDto[], formData: any): Observable<any> {
    let url = ApiPaths.JobSeeker.CreateDocument;
    const docList = { docs: docDto };
    return this.apiService.post(url, docList);
  }

  GetJsList(data: object | undefined): Observable<any> {
    const localurl = ApiPaths.JobSeeker.getJsList;
    return this.apiService.post(localurl, data);
  }

  GetJsJobAllotedList(data: object | undefined): Observable<any> {
    const localurl = ApiPaths.JobSeeker.getJsJobAllotedList;
    return this.apiService.post(localurl, data,false);
  }

  GetJobAllotedListJs(data: object | undefined): Observable<any> {
    const localurl = ApiPaths.JobSeeker.getJsInvitationList;
    return this.apiService.post(localurl, data);
  }

  GetJobAllotedJsInitial(JobId:number){
    const localurl = ApiPaths.JobSeeker.loadJobAllotedListJs(JobId);
    return this.apiService.get(localurl);
  }

  UpdateJobApplicantStatus(idStatusArray:any,type:boolean) {
    const localurl = (type==true?ApiPaths.JobSeeker.UnAssignJobseeker:ApiPaths.JobSeeker.UpdateJAStatus);
    return this.apiService.post(localurl,idStatusArray);
  }

  resentInvitation(resendModel:any) {
    const localurl = ApiPaths.JobSeeker.resendInvitation;
    return this.apiService.post(localurl,resendModel);
  }

  invitationAction(invitModel:any) {
    const localurl = ApiPaths.JobSeeker.InvitationAction;
    return this.apiService.post(localurl,invitModel);
  }

  GetInitialJs(data: object | undefined): Observable<any> {
    const localurl = ApiPaths.JobSeeker.getInitialJs;
    return this.apiService.post(localurl, data);
  }

  updateJobSeekerStatus(JsId: number, status: boolean, type: string) {
    const localurl = ApiPaths.JobSeeker.UpdateStatus;
    const model = { JsId: JsId, Status: status, Type: type };
    return this.apiService.post(localurl, model);
  }

  getJsProfessionalById(JsId: number): Observable<any> {
    const localurl = ApiPaths.JobSeeker.loadProfessionalData(JsId);
    return this.apiService.get(localurl);
  }

  getJsReferenceById(JsId: number): Observable<any> {
    const localurl = ApiPaths.JobSeeker.loadReferenceData(JsId);
    return this.apiService.get(localurl);
  }

  getPreviewById(JsId: number): Observable<any> {
    const localurl = ApiPaths.JobSeeker.loadPreviewData(JsId);
    return this.apiService.get(localurl);
  }

  fetchJobSeekerWithCondition(GetJsModel: any): Observable<any> {
    let url = ApiPaths.JobSeeker.JobSeekerCondi;
    return this.apiService.post(url, GetJsModel);
  }
  GetJSUploadedDoc(jsid:number)
  {
    let url = ApiPaths.JobSeeker.loadJSDocInfoData(jsid);
    return this.apiService.get(url);
  }
  UploadImage(ImageModel: any): Observable<any> {
    let url = ApiPaths.JobSeeker.UploadeImage;
    return this.apiService.post(url, ImageModel);
  }

  UploadResume(ResumeModel: any): Observable<any> {
    let url = ApiPaths.JobSeeker.UploadeResume;
    return this.apiService.post(url, ResumeModel);
  }

  getProfileId(): number {
    return this.profileId;
  }

  setProfileId(profileId: number): void {
    this.profileId = profileId;
  }

  getProImg(): number {
    return this.ProImgPath;
  }

  setProImg(proImgPath: number): void {
    this.ProImgPath = proImgPath;
  }

  getResume(): number {
    return this.ResumePath;
  }

  setResumePath(resumePath: number): void {
    this.ResumePath = resumePath;
  }

  setJsId(jsId: number): void {
    this.jsIdSubject.next(jsId);
  }

  getJsId(): Observable<number | null> {
    return this.jsIdSubject.asObservable();
  }

  GetJobList(listMailSearchVM: any): Observable<any> {
    let localurl = ApiPaths.JobSeeker.JobAllotmentList;
    return this.apiService.post(localurl, listMailSearchVM);
  }

  ResumeExtract(resumeBase64:string,fileType:string): Observable<any> {
    let localurl = ApiPaths.JobSeeker.JsResumeExtract;
    return this.apiService.post(localurl, {base64String:resumeBase64,fileType: fileType});
  }


  GetJobDetailList(JdSearchVM: any): Observable<any> {
    let localurl = ApiPaths.JobSeeker.JobDetailList;
    return this.apiService.post(localurl, JdSearchVM);
  }

  SendInvitation(JobIdList: any): Observable<any> {
    let url = ApiPaths.JobSeeker.SendInvitation;
    return this.apiService.post(url, JobIdList);
  }
  SendInvitationJS(jsModel: any): Observable<any> {
    let url = ApiPaths.JobSeeker.SendInvitationJS;
    return this.apiService.post(url, jsModel);
  }

  DeleteReference(ReferenceId: any) : Observable<any> {
    let url = ApiPaths.JobSeeker.DeleteReference+"/"+ReferenceId;
    return this.apiService.post(url);
  }

  DeleteContact(ContactId: any) : Observable<any> {
    let url = ApiPaths.JobSeeker.DeleteContact+"/"+ContactId;
    return this.apiService.post(url);
  }

  supplierInvitation(data : any): Observable<any> {
    const localurl = ApiPaths.JobSeeker.supplierInvitation;
    return this.apiService.post(localurl, data);
  }

  EvaluateJsForTP(JsId: number): Observable<any> {
    const localurl = ApiPaths.JobSeeker.EvaluateJsForTP(JsId);
    return this.apiService.get(localurl);
  }

  GetLookUpTPSData(JsId: number) {
    const localurl = ApiPaths.JobSeeker.loadTPSData(JsId);
    return this.apiService.get(localurl);
  }

  GetSearchTPSData(TPSSearchVM: any): Observable<any> {
    const localurl = ApiPaths.JobSeeker.loadSearchTPSData;
    return this.apiService.post(localurl, TPSSearchVM);
  }

  GetResumePhysicalPath(resumePath: string): Observable<any> {
    const localurl = ApiPaths.JobSeeker.loadResumePath(resumePath);
    return this.apiService.get(localurl, { responseType: 'blob' });
  }

  getMedia(data: any) {
    let url = ApiPaths.JobSeeker.GetMedia;
    return this.apiService.post(url, data);
  }
}
